const { abstractResource } = require("./abstractResource");

const service = abstractResource("ACCOUNTING");

const Account = {
  ...service("accounts"),

  get_form() {
    return {
      label: null,
      type: null,
      number: null,
      tags: [],
      display: null,
      sub_type: null,
    };
  },
  get_filters() {
    return {
      active: {
        has_values: true,
        number: false,
      },
      form: {
        has_values: false,
        number: null,
      },
    };
  },
};

const AccountLine = {
  ...service("account-lines"),

  get_form() {
    return {
      date: null,
      type: null,
      client: null,
      debit: null,
      credit: null,
      currency: null,
    };
  },
  get_filters() {
    return {
      active: {
        has_values: true,
        number: false,
      },
      form: {
        has_values: false,
        number: null,
      },
    };
  },
};

const AccountTag = {
  ...service("account-tags"),

  get_form() {
    return {
      name: null,
    };
  },
};


module.exports = {
  Account,
  AccountTag,
  AccountLine,
};
